<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="3">
					<search-input
						:label="getMessage_('SWCC000206')"
						paramKey="pgmId"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC001537')"
						paramKey="jobGroupId"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC001536')"
						paramKey="jobId"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC001535')"
						paramKey="jobNm"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>	
				<el-col :span="6">
				<sf-group-wrapper :label="getMessage_('SWCC000204')">
					<el-date-picker
						v-model="searchDate"
						@change="changeSearchDate"
						type="daterange"
						align="right"
						start-placeholder="Start Date"
						end-placeholder="End Date"
						range-separator="~"
						format="yyyy-MM-dd"
						style="height: 38px"
					/>
				</sf-group-wrapper>
				</el-col>		
				<el-col :span="3">
					<useYn-select />					
				</el-col>					
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/comm/qmsbase/BatchHistory/store/helpers';
import SearchInput from './SearchInput.vue';
import UseYnSelect from './UseYnSelect.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},

	data() {
		var fromDate = new Date();				
			fromDate.setDate(-3);
			var fromMonth = parseInt(fromDate.getMonth() + 1);
			var fromday = fromDate.getDate();
			if (fromMonth < 10) fromMonth = '0' + fromMonth;
			if (fromday < 10) fromday = '0' + fromday;
			var from = fromDate.getFullYear() + '-' + fromMonth + '-' + fromday;

			var date = new Date();				
			var month = parseInt(date.getMonth() + 1);		
			var day = date.getDate();
			if (month < 10) month = '0' + month;
			if (day < 10) day = '0' + day;			
			var to = date.getFullYear() + '-' + month + '-' + day;
		return {
			searchDate: [new Date(from), new Date(to)]
		};
	},
	components: { SearchInput , UseYnSelect},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		searchList() {			
			this.$sf_toggleLoading(true);
			this.getBatchHistoryList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		changeSearchDate(data) {			
			let from = this.$moment(data[0]).format('YYYY-MM-DD');
			let to = this.$moment(data[1]).format('YYYY-MM-DD');
			// console.log('changeSearchDate', from);
			this.selectDate({ from, to });
		}
	},	
	async created() {
		try {				
				var fromDate = new Date();				
				fromDate.setDate(-3);
				var fromMonth = parseInt(fromDate.getMonth() + 1);
				var fromday = fromDate.getDate();
				if (fromMonth < 10) fromMonth = '0' + fromMonth;
				if (fromday < 10) fromday = '0' + fromday;
				var from = fromDate.getFullYear() + '-' + fromMonth + '-' + fromday;

				var date = new Date();				
				var month = parseInt(date.getMonth() + 1);		
				var day = date.getDate();
				if (month < 10) month = '0' + month;
				if (day < 10) day = '0' + day;			
				var to = date.getFullYear() + '-' + month + '-' + day;

				this.selectDate({ from, to });
				await this.getCommCodes_({ key: 'useYnList', codeType: 'BATCH_RSLT' });

				let list = [];

				this.useYnList.forEach(row => {
					list.push({
						label: row.commCdName,
						value: row.commCd
					});
				});

				await this.searchList();
			
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
		
	}
};
</script>

<style></style>
